/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { InsertNewTenantOptions, InsertNewTenantResponses } from '../types/InsertNewTenant'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Insert tenant details by admin
 * {@link /v1/tenants}
 */
export function insertNewTenant<ThrowOnError extends boolean = true>(
  options: Options<InsertNewTenantOptions, ThrowOnError>,
): Unwrappable<RequestResult<InsertNewTenantResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/tenants',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<InsertNewTenantResponses, ThrowOnError>>,
  )
}
